import { wrapper, createApiClient, Result, ApiError } from "../base";
import LegacyDatabaseServerDO = App.Data.LegacyDatabaseServerDO;

const basePath = `environment/legacy-database-servers`;
const baseClient = createApiClient();

export default class {
	getLegacyDatabaseServer(): Promise<Result<LegacyDatabaseServerDO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}`));
	}

	updateLegacyDatabaseServer(
		legacyDatabaseServer: LegacyDatabaseServerDO
	): Promise<Result<LegacyDatabaseServerDO, ApiError>> {
		return wrapper(
			baseClient.put(
				`${basePath}/${legacyDatabaseServer.id}`,
				legacyDatabaseServer
			)
		);
	}
}
